import React, {useEffect} from "react";
import EditorLoginReasonModal from "../../editor-login-reason-modal";
import shopSwitchStore from "./shop-switch-store";
import {observer} from "mobx-react";

/**
 * Shows a modal for an Admin with the Editor role to enter the reason for changing a Portal
 */
const ShopSwitchReasonHandler: React.FC = observer(() => {
    useEffect(() => {
        const unsubscribe = shopSwitchStore.subscribeToParentShopSwitchEvent();

        return () => {
            unsubscribe();
        }
    }, []);

    return (shopSwitchStore.showReasonModal && (
        <EditorLoginReasonModal
            onCloseClick={shopSwitchStore.closeReasonModal}
            onLoginAsEditor={shopSwitchStore.resolveWithReason}
        />
    )) ?? null;
});

export default ShopSwitchReasonHandler;

